
<div class="modal right fade" id="newTask" tabindex="-1" role="dialog" aria-labelledby="newTaskLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title fs18" id="newTaskLabel" ng-if="newTaskData.id">KargoGüncelle</h4>
                <h4 class="modal-title fs18" id="newTaskLabel" ng-if="!newTaskData.id">Yeni Kargo</h4>
            </div>

            <form name="newWork" ng-submit="newOrUpdateTask(newWork.$valid)">
                <div class="modal-body">
                    <div class="row">
                        <div class="loading" ng-if="!orderData">
                            <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                        </div>

                        <div class="col-md-12">

                            <div class="form-group">
                                <label for="">Önem Derecesi</label>
                                <div class="radio-custom radio-primary pln radio-inline mb5">
                                    <input type="radio" id="low" value="low" name="type" ng-model="newTaskData.importance">
                                    <label for="low">Düşük</label>
                                </div>
                                <div class="radio-custom radio-primary pln radio-inline mb5">
                                    <input type="radio" id="middle" value="middle" name="type" ng-model="newTaskData.importance">
                                    <label for="middle">Orta</label>
                                </div>
                                <div class="radio-custom radio-primary pln radio-inline mb5">
                                    <input type="radio" id="high" value="high" name="type" ng-model="newTaskData.importance">
                                    <label for="high">Yüksek</label>
                                </div>
                            </div>

                            <div class="form-group hidden">
                                <select name="" id="" class="form-control" ng-model="newTaskData.status_id">
                                    <option value="">KargoDurumu</option>
                                    <option value="{{ item.id }}" ng-value="{{ item.id }}" ng-repeat="item in orderData.steps">{{ item.name }}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <input type="text" ng-model="newTaskData.title" placeholder="KargoBaşlığı" class="form-control input-md">
                            </div>

                            <div class="form-group">
                                <div class="input-group">
                                    <textarea rows="" cols="" ng-model="newTaskData.description" placeholder="KargoAçıklaması " class="form-control input-md"></textarea>
                                    <span class="input-group-addon danger">
                                        <a href="#" class="hint--medium hint--top-left" aria-label="Kargohakkında detaylar girebilir veya not tutabilirsiniz."><i class="fa fa-question-circle"></i> </a>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group">
                                <ui-select 
                                    ng-model="newTaskData.worker_id" 
                                    title="KargoAtanan Kişi" 
                                    duplicates-allowed="false"
                                    required
                                    >
                                    <ui-select-match placeholder="Personel Seçiniz...">
                                        <span ng-bind="$select.selected.full_name"></span>
                                    </ui-select-match>
                                    <ui-select-choices repeat="item.id as item in (orderData.workers | filter: $select.search | filter:filterWorkerFromTeam ) track by $index">
                                        <div class="row mr10 ml10">
                                            <span ng-bind="item.user.full_name"></span>
                                        </div>
                                    </ui-select-choices>
                                </ui-select>
                            </div>

                            <div class="form-group mt5 mb5">
                                <div class="row p5" ng-repeat="item in newTaskData.notification">
                                    <div class="col-md-3 pr5 pl5">
                                        <select ng-model="item.type" class="form-control">
                                            <option value="email">E-Mail</option>
                                            <option value="sms">Sms</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 pr5 pl5">
                                        <input type="text" ng-model="item.time" placeholder="Zaman" class="form-control input-md">
                                    </div>
                                    <div class="col-md-4 pr5 pl5">
                                        <select ng-model="item.period" class="form-control">
                                            <option value="minute">dakika önce</option>
                                            <option value="hour">saat önce</option>
                                            <option value="day">gün önce</option>
                                        </select>
                                    </div>
                                    <div class="col-md-2 pr5 pl5 pt5">
                                        <a href="" ng-click="removeNotification($index)"><i class="fa fa-times"></i></a>
                                    </div>
                                </div>
                                <a href="#" ng-click="addNotification()">
                                    <strong> <i class="fa fa-plus"></i> Bildirim Ekle</strong>
                                </a>
                            </div>

                            <a href="#" class="list-group-item" data-toggle="collapse" data-target="#date">
                                <strong> <i class="fa fa-clock-o"></i> Bitiş Tarihi Seç</strong>
                            </a>
                            <div class="form-group collapse" id="date">
                                <input id="datetimepickerTask" type="text" class="form-control input-md" value="" ng-model="newTaskData.scheduled_time" required>
                            </div>

                            <a href="#" class="list-group-item" data-toggle="collapse" data-target="#file">
                                <strong> <i class="fa fa-file-o"></i> Dosya Ekle</strong>
                            </a>
                            <div 
                                class="form-group collapse" id="file" 
                                ng-class="{ 'has-error': newWork.file.$invalid && newWork.file.$touched}">
                                <span class="btn btn-primary btn-xs btn-file ph5">
                                    <span class="fileupload-new"> <i class="fa fa-cloud"></i> Dosya Yükle</span>
                                    <input type="file" name="file" nv-file-select uploader="taskFiles" multiple>
                                </span>
                                <div class="fileupload fileupload-new" data-provides="fileupload">
                                    <div class="fileupload-preview thumbnail mb20" ng-if="newTaskData.files.length > 0">
                                        <div class="col-md-4" ng-repeat="file in newTaskData.files">
                                                <a 
                                            href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ file.url }}" 
                                            target="__BLANK">

                                                <img 
                                                    ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ file.url }}" 
                                                    ng-if="imageFormats.indexOf(getExtensions(file.url)) != -1"
                                                    class="img-responsive center">

                                                <img 
                                                    src="img/word.png" 
                                                    ng-if="wordFormats.indexOf(getExtensions(file.url)) != -1"
                                                    class="img-responsive center">

                                                <img 
                                                    src="img/excel.png" 
                                                    ng-if="excelFormats.indexOf(getExtensions(file.url)) != -1"
                                                    class="img-responsive center">

                                                <img 
                                                    src="img/pdf.png" 
                                                    ng-if="pdfFormats.indexOf(getExtensions(file.url)) != -1"
                                                    class="img-responsive center">
                                                    
                                                </a>
                                            <a href="#" ng-click="deleteFileFromNewTask(file)" class="btn btn-danger btn-sm m5"><i class="fa fa-trash"></i></a>
                                        </div>
                                    </div>
                                    <div class="progress mt5" ng-if="progress">
                                        <div class="progress-bar progress-bar-success progress-bar-striped active" 
                                            role="progressbar" 
                                            ng-style="{ 'width': taskFiles.progress + '%' }">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <a href="#" class="list-group-item" data-toggle="collapse" data-target="#customer">
                                <strong> <i class="fa fa-university"></i> Müşteri Ekle</strong>
                            </a>

                            <div class="form-group collapse" id="customer">
                                <div angucomplete-alt
                                    ng-model="newTaskData.address.customer_name"
                                    placeholder="Müşteri Adı"
                                    pause="100"
                                    selected-object="addressSelected"
                                    remote-url="api/find-customer?s="
                                    remote-url-data-field="customers"
                                    search-fields="customer_name,phone_number,address"
                                    title-field="customer_name"
                                    description-field="address"
                                    minlength="1"
                                    input-class="form-control input-md"
                                    match-class="highlight"
                                    >
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="modal-footer bg-light">
                    <button type="button" class="btn btn-default" data-dismiss="modal">İptal</button>
                    <button type="submit" class="btn btn-primary">
                        <span ng-if="newTaskData.id">Güncelle</span>
                        <span ng-if="!newTaskData.id">Oluştur</span>
                    </button>
                </div>
            </form>

        </div>
    </div>
</div>
